import { Link as RouterLink } from 'react-router-dom';

import { Icon, Typography } from '@/ui';

import MomentsCard from './MomentsCard';

import type { NextSessionPrepHomeCard } from './sessionReflectionHomeUtils';
import type { FC } from 'react';

import {
  buildMemberMomentsAnalyticsProperties,
  MEMBER_MOMENTS_EVENTS,
  momentsAnalytics,
} from '@/services/momentsAnalytics';

interface NextSessionPrepCardProps {
  prep: NextSessionPrepHomeCard;
}

const NextSessionPrepCard: FC<NextSessionPrepCardProps> = ({ prep }) => (
  <MomentsCard title="Next Session Topics">
    <RouterLink
      aria-label="Topic Ideas for your upcoming session"
      className="flex items-center gap-4 border-0 border-t border-solid border-cement-200 px-8 py-5 text-cement-400 no-underline transition hover:bg-sunny-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-sage-500"
      to={prep.href}
      onClick={() => {
        momentsAnalytics.track(
          MEMBER_MOMENTS_EVENTS.clickedHomeSessionPrep,
          buildMemberMomentsAnalyticsProperties({
            artifactId: prep.artifactId,
            destination: prep.href,
            route: window.location.pathname,
            sessionId: prep.sessionId,
            surface: 'home',
          }),
        );
      }}
    >
      <Typography className="w-[72px] shrink-0 text-cement-400" variant="body1">
        {prep.dateLabel}
      </Typography>
      <Typography
        className="line-clamp-1 min-w-0 flex-1 text-cement-500"
        variant="body1"
      >
        Topic Ideas for your upcoming session
      </Typography>
      <Icon className="shrink-0 text-cement-300" aria-hidden>
        chevron_right
      </Icon>
    </RouterLink>
  </MomentsCard>
);

export default NextSessionPrepCard;
